/**
 * Профиль и активные сессии (§16.6).
 *
 * «Вход через Космос на каждом устройстве отдельный, сессии не мешают
 * друг другу. В профиле — список активных сессий и кнопка
 * «выйти на всех устройствах»».
 */

import { useEffect, useState } from 'react'
import { SessionExpired, api } from '../api/client'
import type { SessionInfo } from '../api/types'
import { formatDateTime } from '../utils/format'

export function SessionsPanel({ onClose }: { onClose: () => void }) {
  const [sessions, setSessions] = useState<SessionInfo[] | null>(null)
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  function handleError(err: unknown) {
    if (err instanceof SessionExpired) {
      window.location.href = err.portalUrl
      return
    }
    setError(err instanceof Error ? err.message : String(err))
  }

  useEffect(() => {
    api.sessions().then(setSessions).catch(handleError)
  }, [])

  async function revokeAll() {
    setBusy(true)
    try {
      await api.revokeAllSessions()
      // Текущая сессия тоже отозвана — назад в портал.
      window.location.href = '/'
    } catch (err) {
      handleError(err)
      setBusy(false)
    }
  }

  async function logout() {
    setBusy(true)
    try {
      const { portal_url } = await api.logout()
      window.location.href = portal_url
    } catch (err) {
      handleError(err)
      setBusy(false)
    }
  }

  return (
    <div className="card sessions-panel">
      <div className="card-row">
        <h2 style={{ margin: 0 }}>Сессии на устройствах</h2>
        <button onClick={onClose} aria-label="Закрыть">
          ✕
        </button>
      </div>

      {error != null && <p className="error">{error}</p>}

      {sessions == null ? (
        <p className="muted">Загружаю…</p>
      ) : (
        sessions.map((session) => (
          <div key={session.id} className={`session-row${session.is_current ? ' current' : ''}`}>
            <div>
              {session.device_label ?? 'неизвестное устройство'}
              {session.is_current && <span className="muted"> · это устройство</span>}
              {session.is_shared_device && <span className="muted"> · чужое устройство</span>}
            </div>
            <div className="muted">{formatDateTime(session.last_activity_at)}</div>
          </div>
        ))
      )}

      <div className="actions">
        <button disabled={busy} onClick={logout}>
          Выйти на этом устройстве
        </button>
        <button disabled={busy} onClick={revokeAll}>
          Выйти на всех устройствах
        </button>
      </div>
    </div>
  )
}
